// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDtQ76MHCLEPCNa4r7zR0-_Bsr58Clg9nI',
    authDomain: 'rms-form.firebaseapp.com',
    projectId: 'rms-form',
    storageBucket: 'rms-form.appspot.com',
    messagingSenderId: '194714009',
    appId: '1:194714009:web:3e4c85edb50a11dc2ddb08',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
